import { combineReducers } from "redux";
import { findItems, getHasStudio, listItems, listItemsRoleCreation } from "./registry-read";

const read = combineReducers({ findItems, getHasStudio, listItems, listItemsRoleCreation });

export default combineReducers({ read });
